import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import UserUtils from '../utils/user.utils';

export const reportsGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = auth.getUser();
  if (user && user.securityLevel >= UserUtils.SECURITY_LEVEL_ADMIN) return true;
  router.navigate(['/login']);
  return false;
};
